import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ApiService } from '../../services/api.service';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../../services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from '../../services/notification.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-chat-modal',
  templateUrl: './chat-modal.component.html',
  styleUrl: './chat-modal.component.scss',
})
export class ChatModalComponent implements OnInit {
  @ViewChild('chatBottom') chatBottom: ElementRef;
  @Input() enquiryId: number;
  chatList: any[] = [];
  messageText: string = '';
  accType: string;

  constructor(
    private activeModal: NgbActiveModal,
    private http: ApiService,
    private user: UserService,
    private notify: NotificationService,
    private store: StorageService
  ) {
    try {
      const rawAccType = this.store.get('acc_type');
      this.accType =
        rawAccType !== undefined && rawAccType !== null
          ? rawAccType.toString()
          : '';
      console.log('riyas', this.accType, typeof this.accType); // should log string
    } catch (error) {
      console.error('Error retrieving or parsing acc_type:', error);
    }
  }

  scrollToBottom(): void {
    try {
      this.chatBottom?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    } catch (err) {
      console.warn('Scroll to bottom failed', err);
    }
  }

  ngOnInit() {
    console.log('accType', this.accType);
    if (this.enquiryId) {
      this.loadChatHistory();
    }
  }

  loadChatHistory() {
    this.http
      .post('retailers/getChatList', { enqId: this.enquiryId })
      .subscribe((res: any) => {
        const data = res?.data || {};

        console.log('Raw keys:', Object.keys(data)); // Should show your timestamps

        if (Object.keys(data).length === 0) {
          console.warn('No chat data found for enquiryId:', this.enquiryId);
        }

        const parsedMessages: any[] = [];

        Object.keys(data).forEach((timestamp) => {
          parsedMessages.push({
            isHeader: true,
            timestamp: timestamp,
          });

          data[timestamp].forEach((msg: any) => {
            parsedMessages.push({
              ...msg,
              timestamp,
              isUser: msg.accType == this.accType, // adjust based on your app
            });
          });
        });

        this.chatList = parsedMessages;

        // Wait for view to update, then scroll to bottom
        setTimeout(() => this.scrollToBottom(), 100);

        console.log('chatList', this.chatList);
      });
  }

  sendMessage() {
    const chatText = this.messageText.trim();
    if (!chatText) return;

    const currentDate = new Date();
    // const timestampKey =
    //   currentDate.toISOString().split('T')[0] +
    //   ' ' +
    //   currentDate.toTimeString().split(' ')[0];

      const fullTimestamp = currentDate
        .toISOString()
        .slice(0, 19)
        .replace('T', ' '); // "YYYY-MM-DD HH:MM:SS"
      const dateOnly = fullTimestamp.split(' ')[0];

    const payload = {
      enqId: this.enquiryId,
      chat: chatText,
      tagId: '',
    };

    // Clear input early for UX
    this.messageText = '';

    this.http.post('retailers/chat', payload).subscribe({
      next: (res: any) => {
        if (res.code == 1) {
          this.notify.showSuccess(res?.response?.message || 'Message sent', '');

          const headerExists = this.chatList.some(
            (item) => item.isHeader && item.timestamp.split(' ')[0] === dateOnly
          );

          if (!headerExists) {
            this.chatList.push({
              isHeader: true,
              timestamp: fullTimestamp,
            });
          }

          this.chatList.push({
            chat: chatText,
            accType: this.accType,
            isUser: true,
            tagId: '',
            timestamp: fullTimestamp,
          });

          setTimeout(() => this.scrollToBottom(), 100);

        } else {
          this.notify.showError(
            res?.response?.message || 'Failed to send message',
            ''
          );
        }
      },
      error: () => {
        this.notify.showError('Send failed', '');
      },
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
